import React, { useState, useEffect, useRef } from "react";
import * as Components from "../../components";
import * as Containers from "../../containers";
import Formatter from "../../utils/data_formatter";
import { SaleBill } from "../../components/SaleBill";
import { useReactToPrint } from "react-to-print";
import { ReceiptType } from "../../utils/enums";
import dayjs from "dayjs";
import { TablePrint } from "../../components/TablePrint";
import UsefulFunctions from "../../utils/UsefulFunctions";

/* import { dataSource, columns } from "../../data"; */
function List(props) {
  const { page } = props;
  const printRef = useRef();
  const printRef1 = useRef();
  const [searchText, setSearchText] = useState("");
  const [isOpenModals, setIsOpenModals] = useState({});
  const [printData, setPrintData] = useState({});

  let data = [];
  let states = {};

  const printBarcode = (record) => {
    setPrintData({ ...record, type: ReceiptType.Баркод });
    print();
  };

  page.columns &&
    page.columns.map((col) => {
      if (col.clickable) {
        col.onCell = (record) => ({
          onClick: () => {
            if (col.dataIndex === "printcode") {
              printBarcode(record);
            } else {
              setIsOpen(true, col.dataIndex, record);
            }
          },
        });
        if (col.Modal) {
          states[`isOpen${col.dataIndex}`] = false;
          states[`data${col.dataIndex}`] = {};
        }
      }
      if (col.dataIndex === "isenable" || col.dataIndex === "delete") {
        col.render = (value, row) => (
          <Formatter
            value={value}
            row={row}
            form={page.forms}
            request={props.request}
            page={page}
            props={props}
            format={col.customRender ? col.customRender : "status"}
          />
        );
      }
      if (col.dataIndex === "details") {
        col.render = (value, row) => (
          <Formatter
            value={value}
            row={row}
            form={page.forms}
            request={props.request}
            auth={props._auth}
            format="See"
          />
        );
      }
      if (col.dataIndex === "SeeInv") {
        col.render = (value, row) => (
          <Formatter
            value={value}
            row={row}
            form={page.forms}
            request={props.request}
            auth={props._auth}
            format="SeeInv"
          />
        );
      }
      if (col.dataIndex === "SeeCnt") {
        col.render = (value, row) => (
          <Formatter
            value={value}
            row={row}
            form={page.forms}
            request={props.request}
            auth={props._auth}
            format="SeeCnt"
          />
        );
      }
      if (col.dataIndex === "SeeBuy") {
        col.render = (value, row) => (
          <Formatter
            value={value}
            row={row}
            form={page.forms}
            request={props.request}
            auth={props._auth}
            format="SeeBuy"
          />
        );
      }
      if (col.dataIndex === "SeeMove") {
        col.render = (value, row) => (
          <Formatter
            value={value}
            row={row}
            form={page.forms}
            request={props.request}
            auth={props._auth}
            format="SeeMove"
          />
        );
      }
      if (col.dataIndex !== "no" && col.dataIndex !== "edit") {
        col.sorter = {
          compare: (rowA, rowB) => {
            if (
              col.dataIndex.includes("ymd") &&
              rowA[col.dataIndex] &&
              rowB[col.dataIndex]
            ) {
              return dayjs(rowA[col.dataIndex]).diff(
                dayjs(rowB[col.dataIndex])
              );
            } else {
              let a = !isNaN(+rowA[col.dataIndex])
                ? Number(rowA[col.dataIndex])
                : rowA[col.dataIndex];
              let b = !isNaN(+rowB[col.dataIndex])
                ? Number(rowB[col.dataIndex])
                : rowB[col.dataIndex];
              if (a < b) return -1;
              if (b < a) return 1;
              return 0;
            }
          },
        };
      }
    });
  if (page.editpermission) {
    let res = UsefulFunctions.checkPermission(props._auth, page.editpermission);
    if (!res) {
      page.columns = page.columns.filter((x) => x.dataIndex !== "edit");
      page.columns = page.columns.filter((x) => x.dataIndex !== "cost");
    }
  }

  useEffect(() => {
    setIsOpenModals(states);
  }, []);

  if (page.isList) {
    if (!page.isPagination) {
      const filterTable =
        props[`res${page.model}`] &&
        props[`res${page.model}`].filter((o) =>
          Object.keys(o).some(
            (k) =>
              o[k] &&
              String(o[k]).toLowerCase().includes(searchText.toLowerCase()) &&
              page.columns.find((col) => col.dataIndex === k)
          )
        );
      data = filterTable;
    } else {
      const filterTable =
        props[`res${page.model}`] &&
        props[`res${page.model}`].reportList &&
        props[`res${page.model}`].reportList.filter((o) =>
          Object.keys(o).some(
            (k) =>
              o[k] &&
              String(o[k]).toLowerCase().includes(searchText.toLowerCase()) &&
              page.columns.find((col) => col.dataIndex === k)
          )
        );
      data = {
        data: filterTable,
        count: props[`res${page.model}`] && props[`res${page.model}`].count,
        footer:
          props[`res${page.model}`] && props[`res${page.model}`].reportSum,
      };
    }
  }

  useEffect(() => {
    if (printData && Object.keys(printData).length > 0) print();
  }, [printData]);

  /* Хайх */
  const handleSearch = (values) => {
    const pagination = JSON.parse(
      localStorage.getItem(`pagination${props.page.url}`)
    );
    values.pagenumber = pagination ? pagination.defaultCurrent - 1 : 0;
    values.count = pagination ? pagination.defaultPageSize : 10;
    values.materialid = 0;
    if (
      (props?.page?.url === "/report/inventory" &&
        props?._auth?.user?.type === 2) ||
      (props?.page?.url === "/report/move/true" &&
        props?._auth?.user?.type === 2) ||
      (props?.page?.url === "/report/move/false" &&
        props?._auth?.user?.type === 2) ||
      (props?.page?.url === "/count/list" && props?._auth?.user?.type === 2)
    ) {
      values.storeid = props?._auth?.user?.storeid;
    }
    if (
      props?.page?.url === "/movement/list" &&
      props?._auth?.user?.type === 2
    ) {
      values.storeid = props?._auth?.user?.storeid;
      values.fromid = props?._auth?.user?.storeid;
    }
    localStorage.setItem(`search${props.page.url}`, JSON.stringify(values));
    props.request({
      url: page.url,
      body: values,
      method: page.method,
      model: page.model,
    });
  };

  const print = useReactToPrint({
    content: () => printRef.current,
  });

  const setIsOpen = (value, name, record) => {
    if (name === "print") {
      setPrintData({
        ...record,
        type: ReceiptType.Карт,
        vatname: props._auth.vatname,
      });
    } else {
      setIsOpenModals((prev) => {
        prev[`isOpen${name}`] = value;
        if (record) prev[`data${name}`] = record;
        else prev[`data${name}`] = {};
        return { ...prev };
      });
    }
  };

  const getContent = () => {
    return (
      <div>
        {/* Жагсаалтын цонхны хайх болон үйлдэл хэсгүүд */}
        <Components.Search
          onSubmit={handleSearch}
          isNew={
            page.checkCashier && props?._auth?.user?.type === 2
              ? false
              : page.isNew
          }
          printRef={printRef1}
          name={page.name}
          onChangeSearch={(e) => setSearchText(e.target.value)}
          controls={page.controls}
          isModal={page.isModal}
          dataSource={
            !page.isPagination
              ? props[`res${page.model}`] && props[`res${page.model}`]
              : props[`res${page.model}`] &&
                props[`res${page.model}`].reportList
          }
          columns={page.columns}
          url={page.url}
          loading={props[`is${page.model}`]}
          props={props}
        />

        {/* Жагсаалтын цонхны хүснэгт page д хамаарах багануудаар зурагдана */}
        <Components.AntdTable
          dataSource={data}
          loading={props[`is${page.model}`]}
          columns={page.columns}
          form={page.forms}
          method={page.method}
          model={page.model}
          isPagination={page.isPagination}
          pagination={true}
          url={page.url}
          isDoubleClick={page.isDoubleClick}
          request={props.request}
        />
        {page.columns &&
          page.columns.map((col) => {
            if (col.Modal) {
              return (
                <col.Modal
                  isOpen={isOpenModals[`isOpen${col.dataIndex}`]}
                  data={isOpenModals[`data${col.dataIndex}`]}
                  dataIndex={col.dataIndex}
                  onSubmit={handleSearch}
                  columns={col.modalColumns}
                  isReturn={col.isReturn}
                  modalUrl={col.modalUrl}
                  modalMethod={col.modalMethod}
                  modalIdKey={col.modalIdKey}
                  modalHeader={col.modalHeader}
                  modalTitles={col.modalTitles}
                  setIsOpen={(value) => setIsOpen(value, col.dataIndex)}
                  {...props}
                />
              );
            }
          })}
        <div className="hidden">
          <SaleBill ref={printRef} data={printData} />
        </div>
        <div className="hidden">
          <TablePrint
            name={page.name}
            dataSource={data}
            columns={page.columns}
            ref={printRef1}
            isPagination={page.isPagination}
          />
        </div>
      </div>
    );
  };

  /* isSettings === true бол тохиргооны цонхнууд гэж үзэн зөвхөн тохиргоо хийх цонх-г зурна */
  if (page.component) {
    return <page.component {...props} {...page} />;
  } else if (page.isSettings) {
    return <Containers.AddOrEdit {...props} />;
  } else {
    /* Ялгаатай үед үндсэн Жагсаалтын цонхыг зурна */
    return getContent();
  }
}

export default List;
